import {GET_MEMBERSHIP_LOG_DETAILS, GET_MEMBERSHIP_LOGS } from "helpers/url_helper";
import { createCrudSlice } from "./createCrudSlice";
const memberShipLogsSlice = createCrudSlice({
  name: "apiLogs",
  urls: {
    getList: GET_MEMBERSHIP_LOGS,
    getDetails: GET_MEMBERSHIP_LOG_DETAILS,
  },
  initialFilters: {},
  hasDropdownList: true,
  defaultDropdownData: [],
  additionalThunks: {},
  initialState: {
    actionType:"",
    userId:"",
    membershipId:"",
    performedByRole:"",
  },
});

// Export actions
export const { setFilter, resetFilters } = memberShipLogsSlice.actions;

// Export thunks
export const {
  getList: getMembershipLogsList,
  getDetails: getMembershipLogDetails,
} = memberShipLogsSlice.thunks;

// Export reducer
export default memberShipLogsSlice.reducer;
